import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { useOrganizationRegionalUIContext } from "./OrganizationRegionalUIContext";
import { OrganizationRegionalFilter } from "./organization-regional-table/organization-regional-filter/OrganizationRegionalFilter";
import {
  fetchOrganizationRegionals,
  createOrganizationRegional,
  updateOrganizationRegional
} from "../../_redux/organization-regional/organizationRegionalAction";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import OrganizationRegionalTable from "./organization-regional-table/OrganizationRegionalTable";
import LoadingAnimation from "./loading-animation/LoadingAnimation";
import { ConfirmationModal } from "../../../Donation/pages/confirmation/confirmation-edit/confirmation-edit-form/ConfirmationModal";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import moment from "moment";
import { Collapse } from "react-bootstrap";
import { RoleChecker } from "../../../../RoleChecker";

export const OrganizationRegionalCard = ({
  match: {
    params: { id }
  },
  history
}) => {
  // * DECLARE HOOKS
  const dispatch = useDispatch();

  const [openFilter, setOpenFilter] = useState(false);

  // * OrganizationRegional UI Context
  const organizationRegionalUIContext = useOrganizationRegionalUIContext();
  const organizationRegionalUIProps = useMemo(() => {
    return {
      queryParams: organizationRegionalUIContext.queryParams,
      setQueryParams: organizationRegionalUIContext.setQueryParams,
      openEditOrganizationRegionalPage:
        organizationRegionalUIContext.openEditOrganizationRegionalPage,
      newOrganizationRegionalButtonClick:
        organizationRegionalUIContext.newOrganizationRegionalButtonClick
    };
  }, [organizationRegionalUIContext]);

  // * Getting curret state of organizationRegional list from store (Redux)
  const { totalCount, entities, listLoading, actionsLoading } = useSelector(
    state => state.superAdminOrganizationRegional,
    shallowEqual
  );

  useEffect(() => {
    // * Requset ke OrganizationRegional Action
    dispatch(
      fetchOrganizationRegionals(organizationRegionalUIProps.queryParams)
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationRegionalUIProps.queryParams, dispatch]);

  const allowCreate = RoleChecker("Create", "master_data_regional");
  const allowEdit = RoleChecker("Edit", "master_data_regional");

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      {/* CREATE FOLDER MODAL */}
      <Card>
        <CardHeader title="Regional">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn mx-1 btn-warning"
              onClick={() => setOpenFilter(!openFilter)}
            >
              Pencarian
            </button>
            {allowCreate && (
              <button
                type="button"
                className="btn mx-1 btn-primary"
                onClick={() => {
                  organizationRegionalUIProps.newOrganizationRegionalButtonClick();
                }}
              >
                Tambah Regional
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Collapse in={openFilter}>
            <div className="collapse-filter">
              <OrganizationRegionalFilter />
            </div>
          </Collapse>
          <OrganizationRegionalTable
            totalCount={totalCount}
            listLoading={listLoading}
            entities={entities}
            queryParams={organizationRegionalUIProps.queryParams}
            setQueryParams={organizationRegionalUIProps.setQueryParams}
            openEditOrganizationRegionalPage={
              organizationRegionalUIProps.openEditOrganizationRegionalPage
            }
            allowEdit={allowEdit}
          />
        </CardBody>
      </Card>
    </>
  );
};
